module.exports = __webpack_public_path__ + "media/images/flags/ir-01c0a08ed6d03c6518ca0e814c8bc91e.svg";